'use client'

import { SkeletonCircle, SkeletonText } from '@sushiswap/ui'
import React from 'react'
import { useAccounts } from 'src/lib/wallet'
import { formatUSD } from 'sushi'
import { PortfolioTokensList } from './portfolio-tokens-list'
import { usePortfolioBalances } from './use-portfolio-balances'

export const PortfolioEvmTokens = () => {
  const { evm } = useAccounts()
  const { data, isLoading, isError } = usePortfolioBalances(evm.address)

  return (
    <div className="flex flex-col gap-y-5 h-full overflow-hidden">
      <div className="px-5">
        <div className="flex flex-col gap-y-3 bg-secondary rounded-xl px-5 py-3">
          <span className="text-sm text-muted-foreground">Total Balance</span>

          <div className="flex flex-col gap-y-2">
            {isLoading && !data && !isError ? (
              <>
                <SkeletonText fontSize="lg" className="!w-1/3" />
                <SkeletonText className="!w-1/2" />
              </>
            ) : (
              <>
                <div className="text-2xl font-bold">
                  {formatUSD(data?.totalUSD ?? 0)}
                </div>

                {isError ? (
                  <div className="text-xs italic text-red-500">
                    An error occurred fetching token balances.
                  </div>
                ) : null}
              </>
            )}
          </div>
        </div>
      </div>

      {isError ? null : isLoading ? (
        <div>
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className="flex w-full items-center px-5 py-3 gap-x-5">
              <SkeletonCircle radius={28} />
              <div className="flex w-full justify-between items-center gap-x-3">
                <div className="basis-3/4 flex flex-col gap-y-1">
                  <SkeletonText fontSize="sm" />
                  <SkeletonText fontSize="xs" />
                </div>
                <div className="basis-1/4 flex flex-col gap-y-1">
                  <SkeletonText fontSize="sm" />
                  <SkeletonText fontSize="xs" />
                </div>
              </div>
            </div>
          ))}
        </div>
      ) : data?.tokens?.length ? (
        <PortfolioTokensList tokens={data.tokens} />
      ) : null}
    </div>
  )
}
